import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import RequestDemoModal from "./components/RequestDemoModal";

// Pages
import Home from "./pages/Home";
import SolutionsOverview from "./pages/SolutionsOverview";
import Security from "./pages/Security";
import Industry4 from "./pages/Industry4";
import Agriculture from "./pages/Agriculture";
import Healthcare from "./pages/Healthcare";
import Services from "./pages/Services";
import Platform from "./pages/Platform";
import Industries from "./pages/Industries";
import About from "./pages/About";
import Contact from "./pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const [isRequestDemoOpen, setIsRequestDemoOpen] = useState(false);

  const openRequestDemo = () => setIsRequestDemoOpen(true);
  const closeRequestDemo = () => setIsRequestDemoOpen(false);

  return (
    <>
      <Navigation onRequestDemo={openRequestDemo} />
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home onRequestDemo={openRequestDemo} />} />
          <Route path="/solutions" element={<SolutionsOverview />} />
          <Route path="/solutions/security" element={<Security onRequestDemo={openRequestDemo} />} />
          <Route path="/solutions/industry-4" element={<Industry4 />} />
          <Route path="/solutions/agriculture" element={<Agriculture />} />
          <Route path="/solutions/healthcare" element={<Healthcare />} />
          <Route path="/services" element={<Services />} />
          <Route path="/platform" element={<Platform onRequestDemo={openRequestDemo} />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
      <Footer />
      <RequestDemoModal isOpen={isRequestDemoOpen} onClose={closeRequestDemo} />
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AppContent />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
